import React, {FC, ReactNode} from "react"
import styled from "styled-components"

import {Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"

const Img = styled.img`
  padding-bottom: ${({theme}) => theme.spacing.three};
  width: 100px;
`

interface Props {
  description: string
  src: string
  alt: string
  renderDescription: () => ReactNode
}

const DefaultDescription: FC<Pick<Props, "description">> = ({description}) => <Body>{description}</Body>

const Empty: FC<Props> = ({description = "", src, alt, renderDescription = DefaultDescription}) => (
  <Flex direction="column" justifyContent="flex-start">
    <Img src={src} alt={alt} />
    {renderDescription({description})}
  </Flex>
)

export default Empty
